import { Sprite } from '@ktag/styleguide/dist/react';
import React from 'react';
import { Button } from '@agissc/ktag-map';
import useAppState from '../../AppStore';

const HamburguerButton = () => {
  const toggleToolbar = useAppState((state) => state.toggleToolbar);
  const isOpen = useAppState((state) => state.toolbar.isOpen);
  const icon = isOpen ? 'cross' : 'menu';

  return (
    <Button onClick={toggleToolbar} additionalClassNames="mobile-button">
      <Sprite id={icon} />
    </Button>
  );
};

export default HamburguerButton;
